/**
 * Build a query string from a record. Omits keys whose values are
 * undefined/null/empty-string so call sites don't have to thread
 * conditionals around every optional param. Keys are emitted in
 * insertion order; the function returns either an empty string or
 * a leading-`?` query string ready to append to a URL.
 *
 * Lives in its own module (not http.ts) so that apiRoutes.ts — and,
 * through it, the edge middleware — can build URLs without pulling
 * the axios instance into the Edge Runtime bundle, where its
 * `require('https')` keep-alive setup crashes on invocation.
 */
export const buildQuery = (params: Record<string, string | number | boolean | undefined | null>): string => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.append(key, String(value));
  });
  const str = search.toString();
  return str ? `?${str}` : '';
};
